// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@charset "UTF-8";
.ChatDialog_dialogOverlay__qFlEJ {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 1000;
  pointer-events: none;
}
.ChatDialog_dialogOverlay__qFlEJ.ChatDialog_mobile__qWT4A {
  background-color: #fff;
  pointer-events: auto;
}
.ChatDialog_dialogOverlay__qFlEJ.ChatDialog_mobile__qWT4A .ChatDialog_dialogContainer__3S3E0 {
  position: static;
  border-radius: 0;
  box-shadow: none;
  width: 100%;
  height: 100%;
}

.ChatDialog_dialogContainer__3S3E0 {
  position: fixed;
  top: 90px;
  right: 20px;
  width: 400px;
  height: calc(100vh - 170px);
  background-color: #fff;
  display: flex;
  flex-direction: column;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
  border-radius: 16px;
  transition: box-shadow 0.3s;
  pointer-events: auto;
}
.ChatDialog_dialogContainer__3S3E0.ChatDialog_dragging__p\\+RSv {
  transition: none;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.2);
  cursor: move;
}

.ChatDialog_dialogHeader__gZ0Tt {
  background-color: #1563be;
  padding: 16px 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  border-radius: 16px 16px 0 0;
  cursor: move;
}
.ChatDialog_mobile__qWT4A .ChatDialog_dialogHeader__gZ0Tt {
  border-radius: 0;
}
.ChatDialog_dialogHeader__gZ0Tt h2 {
  color: white;
  margin: 0;
  font-size: 18px;
  font-weight: 500;
  -webkit-user-select: none;
          user-select: none;
}

.ChatDialog_closeButton__MVmOH {
  background: none;
  border: none;
  color: white;
  font-size: 24px;
  cursor: pointer;
  padding: 0;
  line-height: 1;
  opacity: 0.8;
  transition: opacity 0.3s;
}
.ChatDialog_closeButton__MVmOH:hover {
  opacity: 1;
}

.ChatDialog_messageContainer__o\\+MZn {
  flex: 1 1;
  overflow-y: auto;
  padding: 20px;
  background-color: #f5f5f5;
  border-radius: 0 0 16px 16px;
}
.ChatDialog_mobile__qWT4A .ChatDialog_messageContainer__o\\+MZn {
  border-radius: 0;
}

.ChatDialog_messageWrapper__MsQZ0 {
  display: flex;
  margin-bottom: 20px;
  align-items: flex-start;
}

.ChatDialog_avatar__bzTjI {
  width: 36px;
  height: 36px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  margin-right: 12px;
}
.ChatDialog_avatar__bzTjI img {
  width: 20px;
  height: 20px;
}

.ChatDialog_aiMessage__ENIl8 .ChatDialog_avatar__bzTjI {
  background-color: #1563be;
}
.ChatDialog_aiMessage__ENIl8 .ChatDialog_messageContent__yy12T {
  background-color: #fff;
  border-radius: 12px 12px 12px 0;
}

.ChatDialog_userMessage__5enGr {
  flex-direction: row-reverse;
}
.ChatDialog_userMessage__5enGr .ChatDialog_avatar__bzTjI {
  margin-right: 0;
  margin-left: 12px;
  background-color: #4caf50;
}
.ChatDialog_userMessage__5enGr .ChatDialog_messageContent__yy12T {
  background-color: #e3f2fd;
  border-radius: 12px 12px 0 12px;
}

.ChatDialog_messageContent__yy12T {
  padding: 12px 16px;
  font-size: 14px;
  line-height: 1.5;
  max-width: 70%;
  word-wrap: break-word;
}
.ChatDialog_messageContent__yy12T.ChatDialog_formSubmission__2wpwo {
  background: linear-gradient(135deg, #4CAF50 0%, #45a049 100%);
  color: white;
  border-radius: 16px;
  padding: 16px 24px;
  font-weight: 500;
  -webkit-user-select: none;
          user-select: none;
  pointer-events: none;
  box-shadow: 0 4px 15px rgba(76, 175, 80, 0.2);
  text-align: center;
  font-size: 16px;
  letter-spacing: 1px;
  border: 2px solid rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(5px);
  position: relative;
  margin: 10px 0;
  width: fit-content;
}
.ChatDialog_messageContent__yy12T.ChatDialog_formSubmission__2wpwo::before {
  content: "📝";
  display: block;
  font-size: 24px;
  margin-bottom: 8px;
}
.ChatDialog_messageContent__yy12T.ChatDialog_formSubmission__2wpwo::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  border-radius: 16px;
  background: linear-gradient(45deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0) 100%);
  pointer-events: none;
}
.ChatDialog_messageContent__yy12T .ChatDialog_downloadList__f3gnS {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 10px;
}
.ChatDialog_messageContent__yy12T .ChatDialog_downloadButton__4YSHI {
  width: 100%;
  text-align: left;
  border: 1px solid rgba(21, 99, 190, 0.22);
  background: linear-gradient(135deg, rgba(21, 99, 190, 0.08) 0%, rgba(66, 165, 245, 0.1) 100%);
  border-radius: 12px;
  color: #0d47a1;
  cursor: pointer;
  padding: 10px 12px;
  transition: transform 0.15s ease, box-shadow 0.2s ease, border-color 0.2s ease;
  box-shadow: 0 6px 18px rgba(21, 99, 190, 0.12);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 10px;
  white-space: nowrap;
}
.ChatDialog_messageContent__yy12T .ChatDialog_downloadButton__4YSHI:hover {
  transform: translateY(-1px);
  border-color: rgba(21, 99, 190, 0.35);
  box-shadow: 0 10px 24px rgba(21, 99, 190, 0.18);
}
.ChatDialog_messageContent__yy12T .ChatDialog_downloadButton__4YSHI:active {
  transform: translateY(0);
}
.ChatDialog_messageContent__yy12T .ChatDialog_downloadButtonText__EK4NJ {
  font-size: 14px;
  font-weight: 900;
  letter-spacing: 0.2px;
  color: #0d47a1;
  flex: 1 1;
  min-width: 0;
  overflow: hidden;
  text-overflow: ellipsis;
}
.ChatDialog_messageContent__yy12T .ChatDialog_downloadSub__DJoUg {
  font-size: 12px;
  font-weight: 800;
  color: rgba(13, 71, 161, 0.78);
  background: rgba(255, 255, 255, 0.65);
  border: 1px solid rgba(13, 71, 161, 0.18);
  padding: 4px 10px;
  border-radius: 999px;
  flex-shrink: 0;
  max-width: 170px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.ChatDialog_messageContent__yy12T .ChatDialog_reopenQuestionButton__96944 {
  width: 100%;
  margin-top: 10px;
  text-align: left;
  border: 1px solid rgba(21, 101, 192, 0.25);
  background: linear-gradient(135deg, rgba(21, 101, 192, 0.1) 0%, rgba(66, 165, 245, 0.12) 100%);
  border-radius: 12px;
  color: #0d47a1;
  cursor: pointer;
  padding: 12px 14px;
  font-size: 14px;
  font-weight: 900;
  box-shadow: 0 8px 22px rgba(21, 101, 192, 0.12);
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  transition: transform 0.15s ease, box-shadow 0.2s ease;
}
.ChatDialog_messageContent__yy12T .ChatDialog_reopenQuestionButton__96944:hover {
  transform: translateY(-1px);
  box-shadow: 0 12px 28px rgba(21, 101, 192, 0.18);
}
.ChatDialog_messageContent__yy12T .ChatDialog_reopenQuestionButton__96944:active {
  transform: translateY(0);
}
.ChatDialog_messageContent__yy12T .ChatDialog_reopenQuestionButton__96944 > :first-child {
  flex: 1 1;
  min-width: 0;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: anywhere;
  line-height: 1.35;
}
.ChatDialog_messageContent__yy12T .ChatDialog_reopenQuestionSub__Ccc5Z {
  font-size: 12px;
  font-weight: 800;
  color: rgba(13, 71, 161, 0.75);
  background: rgba(255, 255, 255, 0.55);
  border: 1px solid rgba(13, 71, 161, 0.18);
  padding: 6px 10px;
  border-radius: 10px;
  flex-shrink: 0;
  width: 170px;
  max-width: 170px;
  white-space: normal;
  word-break: break-word;
  overflow-wrap: anywhere;
  line-height: 1.25;
}
.ChatDialog_messageContent__yy12T .ChatDialog_mermaidCopy__yq7Ls {
  display: inline-block;
  margin: 8px 0;
  padding: 8px 12px;
  background-color: #f5f5f5;
  border: 1px solid #ddd;
  border-radius: 6px;
  color: #666;
  cursor: pointer;
  font-size: 13px;
  transition: all 0.2s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}
.ChatDialog_messageContent__yy12T .ChatDialog_mermaidCopy__yq7Ls:hover {
  background-color: #e3f2fd;
  border-color: #1565c0;
  color: #1565c0;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);
}
.ChatDialog_messageContent__yy12T .ChatDialog_mermaidCopy__yq7Ls:active {
  transform: scale(0.98);
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}

.ChatDialog_inputContainer__exhT0 {
  padding: 16px;
  background-color: #fff;
  border-top: 1px solid #eee;
  display: flex;
  gap: 12px;
  align-items: center;
}

.ChatDialog_inputWrapper__\\+a1ct {
  flex: 1 1;
  position: relative;
  display: flex;
  align-items: center;
}

.ChatDialog_attachmentBubble__ZCpyF {
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  background: rgba(21, 99, 190, 0.08);
  border: 1px solid rgba(21, 99, 190, 0.22);
  border-radius: 999px;
  color: #1563be;
  font-size: 12px;
  font-weight: 700;
  height: 20px;
}

.ChatDialog_attachmentText__ugdvl {
  line-height: 1;
}

.ChatDialog_input__Jeaah {
  flex: 1 1;
  border: 1px solid #ddd;
  border-radius: 20px;
  padding: 8px 16px;
  font-size: 14px;
  outline: none;
  transition: border-color 0.3s;
}
.ChatDialog_input__Jeaah:focus {
  border-color: #1563be;
}
.ChatDialog_input__Jeaah:disabled {
  background-color: #f5f5f5;
  cursor: not-allowed;
}

.ChatDialog_disabledInput__ymkUu {
  opacity: 0.85;
}

.ChatDialog_disabledButton__WMLzn {
  opacity: 0.7;
}

.ChatDialog_withAttachment__NyOY4 {
  padding-right: 56px;
}

.ChatDialog_initialQuestionnairePrompt__6rc-9 {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.ChatDialog_promptText__74Ysz {
  font-size: 14px;
  color: #222;
  font-weight: 600;
}

.ChatDialog_promptButton__dYokK {
  align-self: flex-start;
  background: linear-gradient(135deg, #1d78e6 0%, #1563be 55%, #1154a6 100%);
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.18);
  border-radius: 12px;
  padding: 10px 14px;
  font-size: 13px;
  font-weight: 800;
  cursor: pointer;
  transition: transform 0.12s ease, box-shadow 0.2s ease, filter 0.2s ease;
  box-shadow: 0 10px 22px rgba(21, 99, 190, 0.18);
}
.ChatDialog_promptButton__dYokK:hover:not(:disabled) {
  transform: translateY(-1px);
  filter: brightness(1.03);
  box-shadow: 0 14px 30px rgba(21, 99, 190, 0.24);
}
.ChatDialog_promptButton__dYokK:active:not(:disabled) {
  transform: translateY(0);
  box-shadow: 0 8px 18px rgba(21, 99, 190, 0.18);
}
.ChatDialog_promptButton__dYokK:disabled {
  cursor: not-allowed;
  opacity: 0.7;
  box-shadow: none;
}
.ChatDialog_promptButton__dYokK.ChatDialog_completed__2HqdF {
  background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%);
  border-color: rgba(255, 255, 255, 0.22);
  box-shadow: 0 10px 22px rgba(22, 163, 74, 0.18);
}

.ChatDialog_sendButton__ERACI {
  background-color: #1563be;
  color: white;
  border: none;
  border-radius: 50%;
  width: 36px;
  height: 36px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s;
  padding: 8px;
}
.ChatDialog_sendButton__ERACI img {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.ChatDialog_sendButton__ERACI:hover:not(:disabled) {
  background-color: rgb(18.4620853081, 87.0355450237, 167.0379146919);
  transform: scale(1.05);
}
.ChatDialog_sendButton__ERACI:active:not(:disabled) {
  transform: scale(0.95);
}
.ChatDialog_sendButton__ERACI:disabled {
  background-color: #ccc;
  cursor: not-allowed;
}
.ChatDialog_sendButton__ERACI.ChatDialog_loading__YUTPP {
  animation: ChatDialog_pulse__1IsGY 1.5s infinite;
}

@keyframes ChatDialog_pulse__1IsGY {
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
}
.ChatDialog_questionnaireSuccess__I3Pq0 {
  background: linear-gradient(135deg, #f8fff8 0%, #e8f5e8 100%);
  border: 2px solid #4caf50;
  border-radius: 16px;
  padding: 20px;
  margin: 12px 0;
  box-shadow: 0 4px 20px rgba(76, 175, 80, 0.15);
  position: relative;
  overflow: hidden;
}
.ChatDialog_questionnaireSuccess__I3Pq0::before {
  content: "";
  position: absolute;
  top: -50%;
  right: -50%;
  width: 100px;
  height: 100px;
  background: radial-gradient(circle, rgba(76, 175, 80, 0.1) 0%, transparent 70%);
  border-radius: 50%;
}
.ChatDialog_questionnaireSuccess__I3Pq0::after {
  content: "";
  position: absolute;
  bottom: -30%;
  left: -30%;
  width: 80px;
  height: 80px;
  background: radial-gradient(circle, rgba(76, 175, 80, 0.08) 0%, transparent 70%);
  border-radius: 50%;
}

.ChatDialog_successContent__eSR6k {
  position: relative;
  z-index: 1;
  text-align: center;
}
.ChatDialog_successContent__eSR6k h4 {
  margin: 0 0 16px 0;
  color: #1b5e20;
  font-size: 20px;
  font-weight: 700;
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);
}
@media (max-width: 768px) {
  .ChatDialog_successContent__eSR6k h4 {
    font-size: 18px;
  }
}

.ChatDialog_successMessage__wkNil {
  margin: 0 0 20px 0;
  color: #2e7d32;
  font-size: 15px;
  line-height: 1.5;
  opacity: 0.9;
}

.ChatDialog_viewDetailButton__A6ZwB {
  background: linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%);
  color: white;
  border: none;
  border-radius: 12px;
  padding: 14px 28px;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  box-shadow: 0 4px 16px rgba(14, 165, 233, 0.3), 0 2px 4px rgba(0, 0, 0, 0.1);
  position: relative;
  overflow: hidden;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
.ChatDialog_viewDetailButton__A6ZwB::before {
  content: "";
  position: absolute;
  top: 0;
  left: -100%;
  width: 100%;
  height: 100%;
  background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);
  transition: left 0.5s ease;
}
.ChatDialog_viewDetailButton__A6ZwB:hover {
  transform: translateY(-3px);
  box-shadow: 0 8px 25px rgba(14, 165, 233, 0.4), 0 4px 8px rgba(0, 0, 0, 0.15);
}
.ChatDialog_viewDetailButton__A6ZwB:hover::before {
  left: 100%;
}
.ChatDialog_viewDetailButton__A6ZwB:active {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(14, 165, 233, 0.3), 0 2px 4px rgba(0, 0, 0, 0.1);
}

.ChatDialog_detailOverlay__VUTEp {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.75);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1200;
  backdrop-filter: blur(8px);
  animation: ChatDialog_fadeIn__Nx0BR 0.3s ease-out;
  pointer-events: auto;
  overflow: hidden;
}

@keyframes ChatDialog_fadeIn__Nx0BR {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.ChatDialog_detailContainer__3BIUx {
  background: linear-gradient(135deg, #ffffff 0%, #f8fffe 100%);
  border-radius: 20px;
  width: 90%;
  max-width: 750px;
  max-height: 90vh;
  display: flex;
  flex-direction: column;
  box-shadow: 0 25px 80px rgba(0, 0, 0, 0.25), 0 0 0 1px rgba(255, 255, 255, 0.05);
  animation: ChatDialog_slideIn__lGH2u 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);
  position: relative;
  pointer-events: auto;
  overflow: hidden;
}

@keyframes ChatDialog_slideIn__lGH2u {
  from {
    transform: translateY(-20px) scale(0.95);
    opacity: 0;
  }
  to {
    transform: translateY(0) scale(1);
    opacity: 1;
  }
}
.ChatDialog_detailHeader__3l\\+Is {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 28px 32px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.08);
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 20px 20px 0 0;
  flex-shrink: 0;
  position: relative;
}
.ChatDialog_detailHeader__3l\\+Is::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: linear-gradient(135deg, rgba(255, 255, 255, 0.1) 0%, rgba(255, 255, 255, 0.05) 100%);
  border-radius: 20px 20px 0 0;
  pointer-events: none;
}
.ChatDialog_detailHeader__3l\\+Is h3 {
  margin: 0;
  color: #ffffff;
  font-size: 22px;
  font-weight: 700;
  display: flex;
  align-items: center;
  gap: 12px;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  position: relative;
  z-index: 1;
}
.ChatDialog_detailHeader__3l\\+Is h3::before {
  content: "📋";
  font-size: 20px;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
}

.ChatDialog_closeButton__MVmOH {
  background: rgba(255, 255, 255, 0.2);
  border: 2px solid rgba(255, 255, 255, 0.3);
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 20px;
  font-weight: bold;
  color: #ffffff;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  pointer-events: auto;
  z-index: 2;
  position: relative;
  backdrop-filter: blur(10px);
}
.ChatDialog_closeButton__MVmOH:hover {
  background: rgba(255, 255, 255, 0.25);
  border-color: rgba(255, 255, 255, 0.5);
  transform: scale(1.1) rotate(90deg);
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}
.ChatDialog_closeButton__MVmOH:active {
  transform: scale(0.95) rotate(90deg);
}

.ChatDialog_detailContent__6W8zV {
  flex: 1 1;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 32px;
  pointer-events: auto;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.95) 0%, rgba(248, 250, 252, 0.95) 100%);
  scroll-behavior: smooth;
}
.ChatDialog_detailContent__6W8zV::-webkit-scrollbar {
  width: 6px;
}
.ChatDialog_detailContent__6W8zV::-webkit-scrollbar-track {
  background: rgba(0, 0, 0, 0.05);
  border-radius: 3px;
}
.ChatDialog_detailContent__6W8zV::-webkit-scrollbar-thumb {
  background: linear-gradient(180deg, #667eea 0%, #764ba2 100%);
  border-radius: 3px;
  -webkit-transition: all 0.2s ease;
  transition: all 0.2s ease;
}
.ChatDialog_detailContent__6W8zV::-webkit-scrollbar-thumb:hover {
  background: linear-gradient(180deg, #5a6fd8 0%, #6a4190 100%);
}

.ChatDialog_detailSection__CaiSh {
  margin-bottom: 40px;
}
.ChatDialog_detailSection__CaiSh h4 {
  margin: 0 0 24px 0;
  color: #1a202c;
  font-size: 20px;
  font-weight: 700;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
  padding-bottom: 12px;
  display: flex;
  align-items: center;
  gap: 12px;
  position: relative;
}
.ChatDialog_detailSection__CaiSh h4::after {
  content: "";
  position: absolute;
  bottom: 0;
  left: 0;
  width: 60px;
  height: 3px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 2px;
}
.ChatDialog_detailSection__CaiSh h5 {
  margin: 0;
  color: #2d3748;
  font-size: 18px;
  font-weight: 600;
}
.ChatDialog_detailSection__CaiSh p {
  margin: 12px 0;
  color: #4a5568;
  line-height: 1.6;
  font-size: 15px;
}

.ChatDialog_infoGrid__Rec5A {
  display: grid;
  grid-template-columns: 1fr;
  gap: 20px;
}

.ChatDialog_infoItem__0Hl63 {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 24px;
  background: linear-gradient(135deg, #ffffff 0%, #f7fafc 100%);
  border-radius: 16px;
  border: 1px solid rgba(102, 126, 234, 0.1);
  box-shadow: 0 4px 20px rgba(102, 126, 234, 0.08), 0 1px 3px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  position: relative;
  overflow: hidden;
}
.ChatDialog_infoItem__0Hl63::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  height: 100%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
}
.ChatDialog_infoItem__0Hl63:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 30px rgba(102, 126, 234, 0.12), 0 4px 8px rgba(0, 0, 0, 0.08);
}

.ChatDialog_infoLabel__3fF7g {
  font-size: 13px;
  font-weight: 600;
  color: #718096;
  text-transform: uppercase;
  letter-spacing: 1px;
  margin-bottom: 4px;
}

.ChatDialog_infoValue__j0q5- {
  font-size: 17px;
  color: #1a202c;
  font-weight: 600;
  line-height: 1.4;
}

.ChatDialog_processTag__8X84Z {
  display: inline-block;
  color: #667eea;
  font-weight: 600;
  background: rgba(102, 126, 234, 0.1);
  padding: 4px 8px;
  border-radius: 6px;
  margin-right: 8px;
  margin-bottom: 4px;
}

.ChatDialog_processAnswers__v8DQw {
  margin-bottom: 32px;
  padding: 28px;
  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);
  border-radius: 20px;
  border: 1px solid rgba(102, 126, 234, 0.15);
  box-shadow: 0 8px 32px rgba(102, 126, 234, 0.08), 0 2px 8px rgba(0, 0, 0, 0.04);
  transition: all 0.3s ease;
}
.ChatDialog_processAnswers__v8DQw:hover {
  transform: translateY(-4px);
  box-shadow: 0 12px 40px rgba(102, 126, 234, 0.12), 0 4px 12px rgba(0, 0, 0, 0.08);
}

.ChatDialog_processHeader__vwxtI {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 24px;
  padding-bottom: 16px;
  border-bottom: 2px solid rgba(102, 126, 234, 0.2);
  position: relative;
}
.ChatDialog_processHeader__vwxtI::after {
  content: "";
  position: absolute;
  bottom: -2px;
  left: 0;
  width: 40px;
  height: 2px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 1px;
}

.ChatDialog_processIcon__8AFFH {
  font-size: 20px;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
}

.ChatDialog_questionCount__MkKAO {
  font-size: 12px;
  color: #667eea;
  background: rgba(102, 126, 234, 0.1);
  padding: 6px 12px;
  border-radius: 20px;
  margin-left: auto;
  font-weight: 600;
  border: 1px solid rgba(102, 126, 234, 0.2);
}

.ChatDialog_answersList__gHfRO {
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.ChatDialog_answerItem__LbFKC {
  display: flex;
  gap: 16px;
  padding: 20px;
  background: linear-gradient(135deg, #ffffff 0%, #fafbfc 100%);
  border-radius: 16px;
  border: 1px solid rgba(102, 126, 234, 0.1);
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}
.ChatDialog_answerItem__LbFKC::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 3px;
  height: 100%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  transform: scaleY(0);
  transition: transform 0.3s ease;
}
.ChatDialog_answerItem__LbFKC:hover {
  border-color: rgba(102, 126, 234, 0.3);
  box-shadow: 0 8px 25px rgba(102, 126, 234, 0.1), 0 3px 10px rgba(0, 0, 0, 0.05);
  transform: translateY(-2px);
}
.ChatDialog_answerItem__LbFKC:hover::before {
  transform: scaleY(1);
}

.ChatDialog_questionNumber__r4N6e {
  flex-shrink: 0;
  width: 36px;
  height: 36px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 14px;
  font-weight: 700;
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);
  position: relative;
}
.ChatDialog_questionNumber__r4N6e::after {
  content: "";
  position: absolute;
  inset: -2px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 50%;
  z-index: -1;
  opacity: 0.2;
}

.ChatDialog_questionContent__VgLUL {
  flex: 1 1;
  min-width: 0;
}

.ChatDialog_question__U7ING {
  font-weight: 600;
  color: #1a202c;
  margin-bottom: 12px;
  font-size: 16px;
  line-height: 1.5;
  word-wrap: break-word;
}

.ChatDialog_answer__1jqBL {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
}

.ChatDialog_answerLabel__k4HqH {
  font-size: 13px;
  color: #718096;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.ChatDialog_answerValue__P\\+cBN {
  color: #667eea;
  font-size: 15px;
  font-weight: 700;
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%);
  padding: 8px 16px;
  border-radius: 20px;
  border: 1px solid rgba(102, 126, 234, 0.2);
  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.1);
  transition: all 0.2s ease;
}
.ChatDialog_answerValue__P\\+cBN:hover {
  transform: translateY(-1px);
  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.15);
}

.ChatDialog_finalResults__PIjjh {
  display: grid;
  grid-template-columns: 1fr;
  gap: 24px;
}

.ChatDialog_finalResultItem__hxx3y {
  padding: 28px;
  background: linear-gradient(135deg, #f7fafc 0%, #edf2f7 100%);
  border-radius: 20px;
  border: 2px solid transparent;
  background-clip: padding-box;
  box-shadow: 0 10px 40px rgba(102, 126, 234, 0.1), 0 4px 12px rgba(0, 0, 0, 0.05);
  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);
  position: relative;
  overflow: hidden;
}
.ChatDialog_finalResultItem__hxx3y::before {
  content: "";
  position: absolute;
  inset: 0;
  padding: 2px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 20px;
  mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);
  mask-composite: exclude;
  -webkit-mask-composite: xor;
}
.ChatDialog_finalResultItem__hxx3y:hover {
  transform: translateY(-6px) scale(1.02);
  box-shadow: 0 20px 60px rgba(102, 126, 234, 0.15), 0 8px 20px rgba(0, 0, 0, 0.08);
}

.ChatDialog_resultHeader__e67if {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 16px;
}

.ChatDialog_resultIcon__agWWl {
  font-size: 20px;
  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));
}

.ChatDialog_resultProcess__8c5Y0 {
  font-size: 18px;
  font-weight: 700;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  background-clip: text;
}

.ChatDialog_resultValue__V-rF2 {
  font-size: 20px;
  font-weight: 800;
  color: #1a202c;
  background: linear-gradient(135deg, #ffffff 0%, #f7fafc 100%);
  padding: 16px 20px;
  border-radius: 16px;
  border: 1px solid rgba(102, 126, 234, 0.2);
  box-shadow: inset 0 1px 3px rgba(255, 255, 255, 0.5), 0 4px 12px rgba(102, 126, 234, 0.1);
  position: relative;
}
.ChatDialog_resultValue__V-rF2::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  width: 4px;
  height: 100%;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 2px 0 0 2px;
}

@media (max-width: 768px) {
  .ChatDialog_detailContainer__3BIUx {
    width: 95%;
    max-height: 95vh;
    border-radius: 16px;
  }
  .ChatDialog_detailHeader__3l\\+Is {
    padding: 20px 24px;
    border-radius: 16px 16px 0 0;
  }
  .ChatDialog_detailHeader__3l\\+Is h3 {
    font-size: 18px;
    gap: 8px;
  }
  .ChatDialog_detailHeader__3l\\+Is h3::before {
    font-size: 16px;
  }
  .ChatDialog_closeButton__MVmOH {
    width: 36px;
    height: 36px;
    font-size: 18px;
  }
  .ChatDialog_detailContent__6W8zV {
    padding: 24px 20px;
  }
  .ChatDialog_detailSection__CaiSh {
    margin-bottom: 32px;
  }
  .ChatDialog_detailSection__CaiSh h4 {
    font-size: 18px;
    margin-bottom: 20px;
  }
  .ChatDialog_infoItem__0Hl63 {
    padding: 20px;
  }
  .ChatDialog_processAnswers__v8DQw {
    padding: 20px;
    margin-bottom: 24px;
  }
  .ChatDialog_answerItem__LbFKC {
    padding: 16px;
    gap: 12px;
  }
  .ChatDialog_questionNumber__r4N6e {
    width: 32px;
    height: 32px;
    font-size: 12px;
  }
  .ChatDialog_finalResultItem__hxx3y {
    padding: 20px;
  }
  .ChatDialog_resultValue__V-rF2 {
    font-size: 18px;
    padding: 12px 16px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/ChatDialog/index.module.scss"],"names":[],"mappings":"AAAA,gBAAgB;AAAhB;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,aAAA;EAIA,oBAAA;AADF;AAGE;EAEE,sBAAA;EACA,oBAAA;AAFJ;AAII;EACE,gBAAA;EACA,gBAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;AAFN;;AAOA;EACE,eAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,2BAAA;EACA,sBAAA;EACA,aAAA;EACA,sBAAA;EACA,0CAAA;EACA,mBAAA;EACA,2BAAA;EACA,oBAAA;AAJF;AAME;EACE,gBAAA;EACA,yCAAA;EACA,YAAA;AAJJ;;AAQA;EACE,yBAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,4BAAA;EACA,YAAA;AALF;AAOE;EACE,gBAAA;AALJ;AAQE;EACE,YAAA;EACA,SAAA;EACA,eAAA;EACA,gBAAA;EACA,yBAAA;UAAA,iBAAA;AANJ;;AAUA;EACE,gBAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;EACA,eAAA;EACA,UAAA;EACA,cAAA;EACA,YAAA;EACA,wBAAA;AAPF;AASE;EACE,UAAA;AAPJ;;AAWA;EACE,SAAA;EACA,gBAAA;EACA,aAAA;EACA,yBAAA;EACA,4BAAA;AARF;AAUE;EACE,gBAAA;AARJ;;AAYA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;AATF;;AAYA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,cAAA;EACA,kBAAA;AATF;AAWE;EACE,WAAA;EACA,YAAA;AATJ;;AAcE;EACE,yBAAA;AAXJ;AAcE;EACE,sBAAA;EACA,+BAAA;AAZJ;;AAgBA;EACE,2BAAA;AAbF;AAeE;EACE,eAAA;EACA,iBAAA;EACA,yBAAA;AAbJ;AAgBE;EACE,yBAAA;EACA,+BAAA;AAdJ;;AAkBA;EACE,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,cAAA;EACA,qBAAA;AAfF;AAmBE;EACE,6DAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,gBAAA;EACA,yBAAA;UAAA,iBAAA;EACA,oBAAA;EACA,6CAAA;EACA,kBAAA;EACA,eAAA;EACA,mBAAA;EACA,0CAAA;EACA,0BAAA;EACA,kBAAA;EACA,cAAA;EACA,kBAAA;AAjBJ;AAmBI;EACE,aAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;AAjBN;AAoBI;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,mBAAA;EACA,4FAAA;EACA,oBAAA;AAlBN;AAsBE;EACE,aAAA;EACA,sBAAA;EACA,SAAA;EACA,gBAAA;AApBJ;AAuBE;EACE,WAAA;EACA,gBAAA;EACA,yCAAA;EACA,6FAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,8EAAA;EACA,8CAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EAEA,mBAAA;AAtBJ;AAwBI;EACE,2BAAA;EACA,qCAAA;EACA,+CAAA;AAtBN;AAyBI;EACE,wBAAA;AAvBN;AA2BE;EACE,eAAA;EACA,gBAAA;EACA,qBAAA;EACA,cAAA;EACA,SAAA;EACA,YAAA;EACA,gBAAA;EACA,uBAAA;AAzBJ;AA4BE;EACE,eAAA;EACA,gBAAA;EACA,8BAAA;EACA,qCAAA;EACA,yCAAA;EACA,iBAAA;EACA,oBAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;EACA,uBAAA;EACA,mBAAA;AA1BJ;AA6BE;EACE,WAAA;EACA,gBAAA;EACA,gBAAA;EACA,0CAAA;EACA,8FAAA;EACA,mBAAA;EACA,cAAA;EACA,eAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,+CAAA;EACA,aAAA;EACA,uBAAA;EACA,8BAAA;EACA,SAAA;EACA,sDAAA;AA3BJ;AA6BI;EACE,2BAAA;EACA,gDAAA;AA3BN;AA8BI;EACE,wBAAA;AA5BN;AAgCI;EACE,SAAA;EACA,YAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;EACA,iBAAA;AA9BN;AAkCE;EACE,eAAA;EACA,gBAAA;EACA,8BAAA;EACA,qCAAA;EACA,yCAAA;EACA,iBAAA;EACA,mBAAA;EACA,cAAA;EAGA,YAAA;EACA,gBAAA;EACA,mBAAA;EACA,sBAAA;EACA,uBAAA;EACA,iBAAA;AAlCJ;AAqCE;EACE,qBAAA;EACA,aAAA;EACA,iBAAA;EACA,yBAAA;EACA,sBAAA;EACA,kBAAA;EACA,WAAA;EACA,eAAA;EACA,eAAA;EACA,yBAAA;EACA,wCAAA;AAnCJ;AAqCI;EACE,yBAAA;EACA,qBAAA;EACA,cAAA;EACA,yCAAA;AAnCN;AAsCI;EACE,sBAAA;EACA,wCAAA;AApCN;;AAyCA;EACE,aAAA;EACA,sBAAA;EACA,0BAAA;EACA,aAAA;EACA,SAAA;EACA,mBAAA;AAtCF;;AAyCA;EACE,SAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;AAtCF;;AAyCA;EACE,kBAAA;EACA,WAAA;EACA,QAAA;EACA,2BAAA;EACA,oBAAA;EACA,mBAAA;EACA,gBAAA;EACA,mCAAA;EACA,yCAAA;EACA,oBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;AAtCF;;AAyCA;EACE,cAAA;AAtCF;;AAyCA;EACE,SAAA;EACA,sBAAA;EACA,mBAAA;EACA,iBAAA;EACA,eAAA;EACA,aAAA;EACA,6BAAA;AAtCF;AAwCE;EACE,qBAAA;AAtCJ;AAyCE;EACE,yBAAA;EACA,mBAAA;AAvCJ;;AA2CA;EACE,aAAA;AAxCF;;AA2CA;EACE,YAAA;AAxCF;;AA2CA;EACE,mBAAA;AAxCF;;AA2CA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AAxCF;;AA2CA;EACE,eAAA;EACA,WAAA;EACA,gBAAA;AAxCF;;AA2CA;EACE,sBAAA;EACA,0EAAA;EACA,WAAA;EACA,2CAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,wEAAA;EACA,+CAAA;AAxCF;AA0CE;EACE,2BAAA;EACA,wBAAA;EACA,+CAAA;AAxCJ;AA2CE;EACE,wBAAA;EACA,8CAAA;AAzCJ;AA4CE;EACE,mBAAA;EACA,YAAA;EACA,gBAAA;AA1CJ;AA6CE;EACE,6DAAA;EACA,uCAAA;EACA,+CAAA;AA3CJ;;AA+CA;EACE,yBAAA;EACA,YAAA;EACA,YAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,oBAAA;EACA,YAAA;AA5CF;AA8CE;EACE,WAAA;EACA,YAAA;EACA,mBAAA;AA5CJ;AA+CE;EACE,mEAAA;EACA,sBAAA;AA7CJ;AAgDE;EACE,sBAAA;AA9CJ;AAiDE;EACE,sBAAA;EACA,mBAAA;AA/CJ;AAkDE;EACE,gDAAA;AAhDJ;;AAoDA;EACE;IACE,UAAA;EAjDF;EAmDA;IACE,YAAA;EAjDF;EAmDA;IACE,UAAA;EAjDF;AACF;AAuDA;EACE,6DAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,cAAA;EACA,8CAAA;EACA,kBAAA;EACA,gBAAA;AArDF;AAwDE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,+EAAA;EACA,kBAAA;AAtDJ;AAyDE;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,gFAAA;EACA,kBAAA;AAvDJ;;AA6DA;EACE,kBAAA;EACA,UAAA;EACA,kBAAA;AA1DF;AA4DE;EACE,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,yCAAA;AA1DJ;AA4DI;EAPF;IAQI,eAAA;EAzDJ;AACF;;AA6DA;EACE,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,YAAA;AA1DF;;AA+DA;EACE,6DAAA;EACA,YAAA;EACA,YAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iDAAA;EACA,4EACE;EAEF,kBAAA;EACA,gBAAA;EACA,oBAAA;EACA,mBAAA;EACA,QAAA;AA9DF;AAgEE;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,WAAA;EACA,WAAA;EACA,YAAA;EACA,sFAAA;EACA,0BAAA;AA9DJ;AAiEE;EACE,2BAAA;EACA,6EACE;AAhEN;AAmEI;EACE,UAAA;AAjEN;AAqEE;EACE,2BAAA;EACA,4EACE;AApEN;;AA0EA;EACE,eAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,+BAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,0BAAA;EACA,iDAAA;EACA,oBAAA;EAGA,gBAAA;AAzEF;;AA4EA;EACE;IACE,UAAA;EAzEF;EA2EA;IACE,UAAA;EAzEF;AACF;AA4EA;EACE,6DAAA;EACA,mBAAA;EACA,UAAA;EACA,gBAAA;EACA,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,gFACE;EAEF,2EAAA;EACA,kBAAA;EACA,oBAAA;EAGA,gBAAA;AA9EF;;AAiFA;EACE;IACE,wCAAA;IACA,UAAA;EA9EF;EAgFA;IACE,iCAAA;IACA,UAAA;EA9EF;AACF;AAiFA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,4CAAA;EACA,6DAAA;EACA,4BAAA;EACA,cAAA;EACA,kBAAA;AA/EF;AAkFE;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,gGAAA;EACA,4BAAA;EACA,oBAAA;AAhFJ;AAmFE;EACE,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,yCAAA;EACA,kBAAA;EACA,UAAA;AAjFJ;AAmFI;EACE,aAAA;EACA,eAAA;EACA,iDAAA;AAjFN;;AAsFA;EACE,oCAAA;EACA,0CAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;EACA,iDAAA;EACA,oBAAA;EACA,UAAA;EACA,kBAAA;EACA,2BAAA;AAnFF;AAqFE;EACE,qCAAA;EACA,sCAAA;EACA,mCAAA;EACA,0CAAA;AAnFJ;AAsFE;EACE,oCAAA;AApFJ;;AAwFA;EACE,SAAA;EACA,gBAAA;EACA,kBAAA;EACA,aAAA;EACA,oBAAA;EACA,iGAAA;EAuBA,uBAAA;AA3GF;AAuFE;EACE,UAAA;AArFJ;AAwFE;EACE,+BAAA;EACA,kBAAA;AAtFJ;AAyFE;EACE,6DAAA;EACA,kBAAA;EACA,iCAAA;EAAA,yBAAA;AAvFJ;AAyFI;EACE,6DAAA;AAvFN;;AA+FA;EACE,mBAAA;AA5FF;AA8FE;EACE,kBAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;EACA,6DAAA;EACA,6BAAA;EACA,oCAAA;EACA,qBAAA;EACA,oBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;EACA,kBAAA;AA5FJ;AA8FI;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,6DAAA;EACA,kBAAA;AA5FN;AAgGE;EACE,SAAA;EACA,cAAA;EACA,eAAA;EACA,gBAAA;AA9FJ;AAiGE;EACE,cAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;AA/FJ;;AAoGA;EACE,aAAA;EACA,0BAAA;EACA,SAAA;AAjGF;;AAoGA;EACE,aAAA;EACA,sBAAA;EACA,QAAA;EACA,aAAA;EACA,6DAAA;EACA,mBAAA;EACA,0CAAA;EACA,+EACE;EAEF,yBAAA;EACA,kBAAA;EACA,gBAAA;AAnGF;AAqGE;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,YAAA;EACA,6DAAA;AAnGJ;AAsGE;EACE,2BAAA;EACA,+EACE;AArGN;;AA0GA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,yBAAA;EACA,mBAAA;EACA,kBAAA;AAvGF;;AA0GA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,gBAAA;AAvGF;;AA0GA;EACE,qBAAA;EACA,cAAA;EACA,gBAAA;EACA,oCAAA;EACA,gBAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;AAvGF;;AA0GA;EACE,mBAAA;EACA,aAAA;EACA,6DAAA;EACA,mBAAA;EACA,2CAAA;EACA,+EACE;EAEF,yBAAA;AAzGF;AA2GE;EACE,2BAAA;EACA,iFACE;AA1GN;;AA+GA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;EACA,oBAAA;EACA,iDAAA;EACA,kBAAA;AA5GF;AA8GE;EACE,WAAA;EACA,kBAAA;EACA,YAAA;EACA,OAAA;EACA,WAAA;EACA,WAAA;EACA,6DAAA;EACA,kBAAA;AA5GJ;;AAgHA;EACE,eAAA;EACA,iDAAA;AA7GF;;AAgHA;EACE,eAAA;EACA,cAAA;EACA,oCAAA;EACA,iBAAA;EACA,mBAAA;EACA,iBAAA;EACA,gBAAA;EACA,0CAAA;AA7GF;;AAgHA;EACE,aAAA;EACA,sBAAA;EACA,SAAA;AA7GF;;AAgHA;EACE,aAAA;EACA,SAAA;EACA,aAAA;EACA,6DAAA;EACA,mBAAA;EACA,0CAAA;EACA,iDAAA;EACA,kBAAA;EACA,gBAAA;AA7GF;AA+GE;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,YAAA;EACA,6DAAA;EACA,oBAAA;EACA,+BAAA;AA7GJ;AAgHE;EACE,sCAAA;EACA,+EACE;EAEF,2BAAA;AAhHJ;AAkHI;EACE,oBAAA;AAhHN;;AAqHA;EACE,cAAA;EACA,WAAA;EACA,YAAA;EACA,6DAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,eAAA;EACA,gBAAA;EACA,+CAAA;EACA,kBAAA;AAlHF;AAoHE;EACE,WAAA;EACA,kBAAA;EACA,WAAA;EACA,6DAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AAlHJ;;AAsHA;EACE,SAAA;EACA,YAAA;AAnHF;;AAsHA;EACE,gBAAA;EACA,cAAA;EACA,mBAAA;EACA,eAAA;EACA,gBAAA;EACA,qBAAA;AAnHF;;AAsHA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,eAAA;AAnHF;;AAsHA;EACE,eAAA;EACA,cAAA;EACA,gBAAA;EACA,yBAAA;EACA,qBAAA;AAnHF;;AAsHA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,8FAAA;EACA,iBAAA;EACA,mBAAA;EACA,0CAAA;EACA,8CAAA;EACA,yBAAA;AAnHF;AAqHE;EACE,2BAAA;EACA,gDAAA;AAnHJ;;AAuHA;EACE,aAAA;EACA,0BAAA;EACA,SAAA;AApHF;;AAuHA;EACE,aAAA;EACA,6DAAA;EACA,mBAAA;EACA,6BAAA;EACA,4BAAA;EACA,gFACE;EAEF,iDAAA;EACA,kBAAA;EACA,gBAAA;AAtHF;AAwHE;EACE,WAAA;EACA,kBAAA;EACA,QAAA;EACA,YAAA;EACA,6DAAA;EACA,mBAAA;EACA,sEAAA;EACA,uBAAA;EACA,2BAAA;AAtHJ;AAyHE;EACE,uCAAA;EACA,iFACE;AAxHN;;AA6HA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;EACA,mBAAA;AA1HF;;AA6HA;EACE,eAAA;EACA,iDAAA;AA1HF;;AA6HA;EACE,eAAA;EACA,gBAAA;EACA,6DAAA;EACA,6BAAA;EACA,oCAAA;EACA,qBAAA;AA1HF;;AA6HA;EACE,eAAA;EACA,gBAAA;EACA,cAAA;EACA,6DAAA;EACA,kBAAA;EACA,mBAAA;EACA,0CAAA;EACA,yFACE;EAEF,kBAAA;AA5HF;AA8HE;EACE,WAAA;EACA,kBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;EACA,YAAA;EACA,6DAAA;EACA,0BAAA;AA5HJ;;AAiIA;EACE;IACE,UAAA;IACA,gBAAA;IACA,mBAAA;EA9HF;EAiIA;IACE,kBAAA;IACA,4BAAA;EA/HF;EAiIE;IACE,eAAA;IACA,QAAA;EA/HJ;EAiII;IACE,eAAA;EA/HN;EAoIA;IACE,WAAA;IACA,YAAA;IACA,eAAA;EAlIF;EAqIA;IACE,kBAAA;EAnIF;EAsIA;IACE,mBAAA;EApIF;EAsIE;IACE,eAAA;IACA,mBAAA;EApIJ;EAwIA;IACE,aAAA;EAtIF;EAyIA;IACE,aAAA;IACA,mBAAA;EAvIF;EA0IA;IACE,aAAA;IACA,SAAA;EAxIF;EA2IA;IACE,WAAA;IACA,YAAA;IACA,eAAA;EAzIF;EA4IA;IACE,aAAA;EA1IF;EA6IA;IACE,eAAA;IACA,kBAAA;EA3IF;AACF","sourcesContent":[".dialogOverlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  z-index: 1000;\r\n\r\n  // 关键：允许点击/拖拽穿透到背后页面（例如 MermaidDiagram/Home）\r\n  // 只有对话框本体需要接收事件。\r\n  pointer-events: none;\r\n\r\n  &.mobile {\r\n    // 移动端使用全屏对话框，需要阻止背景交互\r\n    background-color: #fff;\r\n    pointer-events: auto;\r\n\r\n    .dialogContainer {\r\n      position: static;\r\n      border-radius: 0;\r\n      box-shadow: none;\r\n      width: 100%;\r\n      height: 100%;\r\n    }\r\n  }\r\n}\r\n\r\n.dialogContainer {\r\n  position: fixed;\r\n  top: 90px;\r\n  right: 20px;\r\n  width: 400px;\r\n  height: calc(100vh - 170px);\r\n  background-color: #fff;\r\n  display: flex;\r\n  flex-direction: column;\r\n  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\r\n  border-radius: 16px;\r\n  transition: box-shadow 0.3s;\r\n  pointer-events: auto;\r\n\r\n  &.dragging {\r\n    transition: none;\r\n    box-shadow: 0 8px 30px rgba(0, 0, 0, 0.2);\r\n    cursor: move;\r\n  }\r\n}\r\n\r\n.dialogHeader {\r\n  background-color: #1563be;\r\n  padding: 16px 20px;\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  border-radius: 16px 16px 0 0;\r\n  cursor: move;\r\n\r\n  .mobile & {\r\n    border-radius: 0;\r\n  }\r\n\r\n  h2 {\r\n    color: white;\r\n    margin: 0;\r\n    font-size: 18px;\r\n    font-weight: 500;\r\n    user-select: none;\r\n  }\r\n}\r\n\r\n.closeButton {\r\n  background: none;\r\n  border: none;\r\n  color: white;\r\n  font-size: 24px;\r\n  cursor: pointer;\r\n  padding: 0;\r\n  line-height: 1;\r\n  opacity: 0.8;\r\n  transition: opacity 0.3s;\r\n\r\n  &:hover {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n.messageContainer {\r\n  flex: 1;\r\n  overflow-y: auto;\r\n  padding: 20px;\r\n  background-color: #f5f5f5;\r\n  border-radius: 0 0 16px 16px;\r\n\r\n  .mobile & {\r\n    border-radius: 0;\r\n  }\r\n}\r\n\r\n.messageWrapper {\r\n  display: flex;\r\n  margin-bottom: 20px;\r\n  align-items: flex-start;\r\n}\r\n\r\n.avatar {\r\n  width: 36px;\r\n  height: 36px;\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-shrink: 0;\r\n  margin-right: 12px;\r\n\r\n  img {\r\n    width: 20px;\r\n    height: 20px;\r\n  }\r\n}\r\n\r\n.aiMessage {\r\n  .avatar {\r\n    background-color: #1563be;\r\n  }\r\n\r\n  .messageContent {\r\n    background-color: #fff;\r\n    border-radius: 12px 12px 12px 0;\r\n  }\r\n}\r\n\r\n.userMessage {\r\n  flex-direction: row-reverse;\r\n  \r\n  .avatar {\r\n    margin-right: 0;\r\n    margin-left: 12px;\r\n    background-color: #4caf50;\r\n  }\r\n\r\n  .messageContent {\r\n    background-color: #e3f2fd;\r\n    border-radius: 12px 12px 0 12px;\r\n  }\r\n}\r\n\r\n.messageContent {\r\n  padding: 12px 16px;\r\n  font-size: 14px;\r\n  line-height: 1.5;\r\n  max-width: 70%;\r\n  word-wrap: break-word;\r\n\r\n  // 删除了 thinkingMessage 样式，现在使用 LoadingAnimation 组件\r\n\r\n  &.formSubmission {\r\n    background: linear-gradient(135deg, #4CAF50 0%, #45a049 100%);\r\n    color: white;\r\n    border-radius: 16px;\r\n    padding: 16px 24px;\r\n    font-weight: 500;\r\n    user-select: none;\r\n    pointer-events: none;\r\n    box-shadow: 0 4px 15px rgba(76, 175, 80, 0.2);\r\n    text-align: center;\r\n    font-size: 16px;\r\n    letter-spacing: 1px;\r\n    border: 2px solid rgba(255, 255, 255, 0.1);\r\n    backdrop-filter: blur(5px);\r\n    position: relative;\r\n    margin: 10px 0;\r\n    width: fit-content;\r\n    \r\n    &::before {\r\n      content: '📝';\r\n      display: block;\r\n      font-size: 24px;\r\n      margin-bottom: 8px;\r\n    }\r\n\r\n    &::after {\r\n      content: '';\r\n      position: absolute;\r\n      top: 0;\r\n      left: 0;\r\n      right: 0;\r\n      bottom: 0;\r\n      border-radius: 16px;\r\n      background: linear-gradient(45deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0) 100%);\r\n      pointer-events: none;\r\n    }\r\n  }\r\n\r\n  .downloadList {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 10px;\r\n    margin-top: 10px;\r\n  }\r\n\r\n  .downloadButton {\r\n    width: 100%;\r\n    text-align: left;\r\n    border: 1px solid rgba(21, 99, 190, 0.22);\r\n    background: linear-gradient(135deg, rgba(21, 99, 190, 0.08) 0%, rgba(66, 165, 245, 0.10) 100%);\r\n    border-radius: 12px;\r\n    color: #0d47a1;\r\n    cursor: pointer;\r\n    padding: 10px 12px;\r\n    transition: transform 0.15s ease, box-shadow 0.2s ease, border-color 0.2s ease;\r\n    box-shadow: 0 6px 18px rgba(21, 99, 190, 0.12);\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: space-between;\r\n    gap: 10px;\r\n\r\n    white-space: nowrap;\r\n\r\n    &:hover {\r\n      transform: translateY(-1px);\r\n      border-color: rgba(21, 99, 190, 0.35);\r\n      box-shadow: 0 10px 24px rgba(21, 99, 190, 0.18);\r\n    }\r\n\r\n    &:active {\r\n      transform: translateY(0);\r\n    }\r\n  }\r\n\r\n  .downloadButtonText {\r\n    font-size: 14px;\r\n    font-weight: 900;\r\n    letter-spacing: 0.2px;\r\n    color: #0d47a1;\r\n    flex: 1;\r\n    min-width: 0;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n  }\r\n\r\n  .downloadSub {\r\n    font-size: 12px;\r\n    font-weight: 800;\r\n    color: rgba(13, 71, 161, 0.78);\r\n    background: rgba(255, 255, 255, 0.65);\r\n    border: 1px solid rgba(13, 71, 161, 0.18);\r\n    padding: 4px 10px;\r\n    border-radius: 999px;\r\n    flex-shrink: 0;\r\n    max-width: 170px;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n  }\r\n\r\n  .reopenQuestionButton {\r\n    width: 100%;\r\n    margin-top: 10px;\r\n    text-align: left;\r\n    border: 1px solid rgba(21, 101, 192, 0.25);\r\n    background: linear-gradient(135deg, rgba(21, 101, 192, 0.10) 0%, rgba(66, 165, 245, 0.12) 100%);\r\n    border-radius: 12px;\r\n    color: #0d47a1;\r\n    cursor: pointer;\r\n    padding: 12px 14px;\r\n    font-size: 14px;\r\n    font-weight: 900;\r\n    box-shadow: 0 8px 22px rgba(21, 101, 192, 0.12);\r\n    display: flex;\r\n    align-items: flex-start;\r\n    justify-content: space-between;\r\n    gap: 10px;\r\n    transition: transform 0.15s ease, box-shadow 0.2s ease;\r\n\r\n    &:hover {\r\n      transform: translateY(-1px);\r\n      box-shadow: 0 12px 28px rgba(21, 101, 192, 0.18);\r\n    }\r\n\r\n    &:active {\r\n      transform: translateY(0);\r\n    }\r\n\r\n    // 左侧主按钮文案：允许占据剩余空间，且正常换行，避免被右侧挤成“竖排一列字”\r\n    & > :first-child {\r\n      flex: 1;\r\n      min-width: 0;\r\n      white-space: normal;\r\n      word-break: break-word;\r\n      overflow-wrap: anywhere;\r\n      line-height: 1.35;\r\n    }\r\n  }\r\n\r\n  .reopenQuestionSub {\r\n    font-size: 12px;\r\n    font-weight: 800;\r\n    color: rgba(13, 71, 161, 0.75);\r\n    background: rgba(255, 255, 255, 0.55);\r\n    border: 1px solid rgba(13, 71, 161, 0.18);\r\n    padding: 6px 10px;\r\n    border-radius: 10px;\r\n    flex-shrink: 0;\r\n\r\n    // 右侧说明：固定宽度 + 多行展示，尽可能展示完整文本\r\n    width: 170px;\r\n    max-width: 170px;\r\n    white-space: normal;\r\n    word-break: break-word;\r\n    overflow-wrap: anywhere;\r\n    line-height: 1.25;\r\n  }\r\n\r\n  .mermaidCopy {\r\n    display: inline-block;\r\n    margin: 8px 0;\r\n    padding: 8px 12px;\r\n    background-color: #f5f5f5;\r\n    border: 1px solid #ddd;\r\n    border-radius: 6px;\r\n    color: #666;\r\n    cursor: pointer;\r\n    font-size: 13px;\r\n    transition: all 0.2s ease;\r\n    box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\r\n\r\n    &:hover {\r\n      background-color: #e3f2fd;\r\n      border-color: #1565c0;\r\n      color: #1565c0;\r\n      box-shadow: 0 2px 6px rgba(0, 0, 0, 0.15);\r\n    }\r\n\r\n    &:active {\r\n      transform: scale(0.98);\r\n      box-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\r\n    }\r\n  }\r\n}\r\n\r\n.inputContainer {\r\n  padding: 16px;\r\n  background-color: #fff;\r\n  border-top: 1px solid #eee;\r\n  display: flex;\r\n  gap: 12px;\r\n  align-items: center;\r\n}\r\n\r\n.inputWrapper {\r\n  flex: 1;\r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n}\r\n\r\n.attachmentBubble {\r\n  position: absolute;\r\n  right: 10px;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  display: inline-flex;\r\n  align-items: center;\r\n  padding: 2px 8px;\r\n  background: rgba(21, 99, 190, 0.08);\r\n  border: 1px solid rgba(21, 99, 190, 0.22);\r\n  border-radius: 999px;\r\n  color: #1563be;\r\n  font-size: 12px;\r\n  font-weight: 700;\r\n  height: 20px;\r\n}\r\n\r\n.attachmentText {\r\n  line-height: 1;\r\n}\r\n\r\n.input {\r\n  flex: 1;\r\n  border: 1px solid #ddd;\r\n  border-radius: 20px;\r\n  padding: 8px 16px;\r\n  font-size: 14px;\r\n  outline: none;\r\n  transition: border-color 0.3s;\r\n\r\n  &:focus {\r\n    border-color: #1563be;\r\n  }\r\n\r\n  &:disabled {\r\n    background-color: #f5f5f5;\r\n    cursor: not-allowed;\r\n  }\r\n}\r\n\r\n.disabledInput {\r\n  opacity: 0.85;\r\n}\r\n\r\n.disabledButton {\r\n  opacity: 0.7;\r\n}\r\n\r\n.withAttachment {\r\n  padding-right: 56px;\r\n}\r\n\r\n.initialQuestionnairePrompt {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n}\r\n\r\n.promptText {\r\n  font-size: 14px;\r\n  color: #222;\r\n  font-weight: 600;\r\n}\r\n\r\n.promptButton {\r\n  align-self: flex-start;\r\n  background: linear-gradient(135deg, #1d78e6 0%, #1563be 55%, #1154a6 100%);\r\n  color: #fff;\r\n  border: 1px solid rgba(255, 255, 255, 0.18);\r\n  border-radius: 12px;\r\n  padding: 10px 14px;\r\n  font-size: 13px;\r\n  font-weight: 800;\r\n  cursor: pointer;\r\n  transition: transform 0.12s ease, box-shadow 0.2s ease, filter 0.2s ease;\r\n  box-shadow: 0 10px 22px rgba(21, 99, 190, 0.18);\r\n\r\n  &:hover:not(:disabled) {\r\n    transform: translateY(-1px);\r\n    filter: brightness(1.03);\r\n    box-shadow: 0 14px 30px rgba(21, 99, 190, 0.24);\r\n  }\r\n\r\n  &:active:not(:disabled) {\r\n    transform: translateY(0);\r\n    box-shadow: 0 8px 18px rgba(21, 99, 190, 0.18);\r\n  }\r\n\r\n  &:disabled {\r\n    cursor: not-allowed;\r\n    opacity: 0.7;\r\n    box-shadow: none;\r\n  }\r\n\r\n  &.completed {\r\n    background: linear-gradient(135deg, #22c55e 0%, #16a34a 100%);\r\n    border-color: rgba(255, 255, 255, 0.22);\r\n    box-shadow: 0 10px 22px rgba(22, 163, 74, 0.18);\r\n  }\r\n}\r\n\r\n.sendButton {\r\n  background-color: #1563be;\r\n  color: white;\r\n  border: none;\r\n  border-radius: 50%;\r\n  width: 36px;\r\n  height: 36px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  cursor: pointer;\r\n  transition: all 0.3s;\r\n  padding: 8px;\r\n\r\n  img {\r\n    width: 100%;\r\n    height: 100%;\r\n    object-fit: contain;\r\n  }\r\n\r\n  &:hover:not(:disabled) {\r\n    background-color: darken(#1563be, 5%);\r\n    transform: scale(1.05);\r\n  }\r\n\r\n  &:active:not(:disabled) {\r\n    transform: scale(0.95);\r\n  }\r\n\r\n  &:disabled {\r\n    background-color: #ccc;\r\n    cursor: not-allowed;\r\n  }\r\n\r\n  &.loading {\r\n    animation: pulse 1.5s infinite;\r\n  }\r\n}\r\n\r\n@keyframes pulse {\r\n  0% {\r\n    opacity: 1;\r\n  }\r\n  50% {\r\n    opacity: 0.5;\r\n  }\r\n  100% {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n// 删除了 thinking 动画，现在使用 LoadingAnimation 组件\r\n\r\n// 问卷提交成功样式 - 重新设计\r\n.questionnaireSuccess {\r\n  background: linear-gradient(135deg, #f8fff8 0%, #e8f5e8 100%);\r\n  border: 2px solid #4caf50;\r\n  border-radius: 16px;\r\n  padding: 20px;\r\n  margin: 12px 0;\r\n  box-shadow: 0 4px 20px rgba(76, 175, 80, 0.15);\r\n  position: relative;\r\n  overflow: hidden;\r\n\r\n  // 添加装饰性背景元素\r\n  &::before {\r\n    content: '';\r\n    position: absolute;\r\n    top: -50%;\r\n    right: -50%;\r\n    width: 100px;\r\n    height: 100px;\r\n    background: radial-gradient(circle, rgba(76, 175, 80, 0.1) 0%, transparent 70%);\r\n    border-radius: 50%;\r\n  }\r\n\r\n  &::after {\r\n    content: '';\r\n    position: absolute;\r\n    bottom: -30%;\r\n    left: -30%;\r\n    width: 80px;\r\n    height: 80px;\r\n    background: radial-gradient(circle, rgba(76, 175, 80, 0.08) 0%, transparent 70%);\r\n    border-radius: 50%;\r\n  }\r\n}\r\n\r\n// 删除了 successIcon 样式，因为不再使用图标\r\n\r\n.successContent {\r\n  position: relative;\r\n  z-index: 1;\r\n  text-align: center;\r\n\r\n  h4 {\r\n    margin: 0 0 16px 0;\r\n    color: #1b5e20;\r\n    font-size: 20px;\r\n    font-weight: 700;\r\n    text-shadow: 0 1px 2px rgba(0, 0, 0, 0.1);\r\n\r\n    @media (max-width: 768px) {\r\n      font-size: 18px;\r\n    }\r\n  }\r\n}\r\n\r\n.successMessage {\r\n  margin: 0 0 20px 0;\r\n  color: #2e7d32;\r\n  font-size: 15px;\r\n  line-height: 1.5;\r\n  opacity: 0.9;\r\n}\r\n\r\n// 移除了推荐结果相关样式，现在只在详情弹窗中显示\r\n\r\n.viewDetailButton {\r\n  background: linear-gradient(135deg, #0ea5e9 0%, #0284c7 100%);\r\n  color: white;\r\n  border: none;\r\n  border-radius: 12px;\r\n  padding: 14px 28px;\r\n  font-size: 15px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n  box-shadow:\r\n    0 4px 16px rgba(14, 165, 233, 0.3),\r\n    0 2px 4px rgba(0, 0, 0, 0.1);\r\n  position: relative;\r\n  overflow: hidden;\r\n  display: inline-flex;\r\n  align-items: center;\r\n  gap: 8px;\r\n\r\n  &::before {\r\n    content: '';\r\n    position: absolute;\r\n    top: 0;\r\n    left: -100%;\r\n    width: 100%;\r\n    height: 100%;\r\n    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.2), transparent);\r\n    transition: left 0.5s ease;\r\n  }\r\n\r\n  &:hover {\r\n    transform: translateY(-3px);\r\n    box-shadow:\r\n      0 8px 25px rgba(14, 165, 233, 0.4),\r\n      0 4px 8px rgba(0, 0, 0, 0.15);\r\n\r\n    &::before {\r\n      left: 100%;\r\n    }\r\n  }\r\n\r\n  &:active {\r\n    transform: translateY(-1px);\r\n    box-shadow:\r\n      0 4px 12px rgba(14, 165, 233, 0.3),\r\n      0 2px 4px rgba(0, 0, 0, 0.1);\r\n  }\r\n}\r\n\r\n// 问卷详情弹窗样式 - 重新设计美观界面\r\n.detailOverlay {\r\n  position: fixed;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: rgba(0, 0, 0, 0.75);\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  z-index: 1200;\r\n  backdrop-filter: blur(8px);\r\n  animation: fadeIn 0.3s ease-out;\r\n  pointer-events: auto;\r\n\r\n  // 确保滚动事件不会传播到底层\r\n  overflow: hidden;\r\n}\r\n\r\n@keyframes fadeIn {\r\n  from {\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n.detailContainer {\r\n  background: linear-gradient(135deg, #ffffff 0%, #f8fffe 100%);\r\n  border-radius: 20px;\r\n  width: 90%;\r\n  max-width: 750px;\r\n  max-height: 90vh;\r\n  display: flex;\r\n  flex-direction: column;\r\n  box-shadow:\r\n    0 25px 80px rgba(0, 0, 0, 0.25),\r\n    0 0 0 1px rgba(255, 255, 255, 0.05);\r\n  animation: slideIn 0.4s cubic-bezier(0.34, 1.56, 0.64, 1);\r\n  position: relative;\r\n  pointer-events: auto;\r\n\r\n  // 确保容器本身不滚动\r\n  overflow: hidden;\r\n}\r\n\r\n@keyframes slideIn {\r\n  from {\r\n    transform: translateY(-20px) scale(0.95);\r\n    opacity: 0;\r\n  }\r\n  to {\r\n    transform: translateY(0) scale(1);\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n.detailHeader {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  align-items: center;\r\n  padding: 28px 32px;\r\n  border-bottom: 1px solid rgba(0, 0, 0, 0.08);\r\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n  border-radius: 20px 20px 0 0;\r\n  flex-shrink: 0; // 防止头部被压缩\r\n  position: relative;\r\n\r\n  // 添加装饰性元素\r\n  &::before {\r\n    content: '';\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background: linear-gradient(135deg, rgba(255,255,255,0.1) 0%, rgba(255,255,255,0.05) 100%);\r\n    border-radius: 20px 20px 0 0;\r\n    pointer-events: none;\r\n  }\r\n\r\n  h3 {\r\n    margin: 0;\r\n    color: #ffffff;\r\n    font-size: 22px;\r\n    font-weight: 700;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 12px;\r\n    text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\r\n    position: relative;\r\n    z-index: 1;\r\n\r\n    &::before {\r\n      content: '📋';\r\n      font-size: 20px;\r\n      filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));\r\n    }\r\n  }\r\n}\r\n\r\n.closeButton {\r\n  background: rgba(255, 255, 255, 0.2);\r\n  border: 2px solid rgba(255, 255, 255, 0.3);\r\n  border-radius: 50%;\r\n  width: 40px;\r\n  height: 40px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  cursor: pointer;\r\n  font-size: 20px;\r\n  font-weight: bold;\r\n  color: #ffffff;\r\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n  pointer-events: auto;\r\n  z-index: 2;\r\n  position: relative;\r\n  backdrop-filter: blur(10px);\r\n\r\n  &:hover {\r\n    background: rgba(255, 255, 255, 0.25);\r\n    border-color: rgba(255, 255, 255, 0.5);\r\n    transform: scale(1.1) rotate(90deg);\r\n    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);\r\n  }\r\n\r\n  &:active {\r\n    transform: scale(0.95) rotate(90deg);\r\n  }\r\n}\r\n\r\n.detailContent {\r\n  flex: 1;\r\n  overflow-y: auto;\r\n  overflow-x: hidden;\r\n  padding: 32px;\r\n  pointer-events: auto;\r\n  background: linear-gradient(180deg, rgba(255,255,255,0.95) 0%, rgba(248,250,252,0.95) 100%);\r\n\r\n  // 自定义滚动条样式\r\n  &::-webkit-scrollbar {\r\n    width: 6px;\r\n  }\r\n\r\n  &::-webkit-scrollbar-track {\r\n    background: rgba(0, 0, 0, 0.05);\r\n    border-radius: 3px;\r\n  }\r\n\r\n  &::-webkit-scrollbar-thumb {\r\n    background: linear-gradient(180deg, #667eea 0%, #764ba2 100%);\r\n    border-radius: 3px;\r\n    transition: all 0.2s ease;\r\n\r\n    &:hover {\r\n      background: linear-gradient(180deg, #5a6fd8 0%, #6a4190 100%);\r\n    }\r\n  }\r\n\r\n  // 确保内容可以正常滚动\r\n  scroll-behavior: smooth;\r\n}\r\n\r\n.detailSection {\r\n  margin-bottom: 40px;\r\n\r\n  h4 {\r\n    margin: 0 0 24px 0;\r\n    color: #1a202c;\r\n    font-size: 20px;\r\n    font-weight: 700;\r\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n    -webkit-background-clip: text;\r\n    -webkit-text-fill-color: transparent;\r\n    background-clip: text;\r\n    padding-bottom: 12px;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 12px;\r\n    position: relative;\r\n\r\n    &::after {\r\n      content: '';\r\n      position: absolute;\r\n      bottom: 0;\r\n      left: 0;\r\n      width: 60px;\r\n      height: 3px;\r\n      background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n      border-radius: 2px;\r\n    }\r\n  }\r\n\r\n  h5 {\r\n    margin: 0;\r\n    color: #2d3748;\r\n    font-size: 18px;\r\n    font-weight: 600;\r\n  }\r\n\r\n  p {\r\n    margin: 12px 0;\r\n    color: #4a5568;\r\n    line-height: 1.6;\r\n    font-size: 15px;\r\n  }\r\n}\r\n\r\n// 基本信息网格布局\r\n.infoGrid {\r\n  display: grid;\r\n  grid-template-columns: 1fr;\r\n  gap: 20px;\r\n}\r\n\r\n.infoItem {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 8px;\r\n  padding: 24px;\r\n  background: linear-gradient(135deg, #ffffff 0%, #f7fafc 100%);\r\n  border-radius: 16px;\r\n  border: 1px solid rgba(102, 126, 234, 0.1);\r\n  box-shadow:\r\n    0 4px 20px rgba(102, 126, 234, 0.08),\r\n    0 1px 3px rgba(0, 0, 0, 0.05);\r\n  transition: all 0.3s ease;\r\n  position: relative;\r\n  overflow: hidden;\r\n\r\n  &::before {\r\n    content: '';\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 4px;\r\n    height: 100%;\r\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n  }\r\n\r\n  &:hover {\r\n    transform: translateY(-2px);\r\n    box-shadow:\r\n      0 8px 30px rgba(102, 126, 234, 0.12),\r\n      0 4px 8px rgba(0, 0, 0, 0.08);\r\n  }\r\n}\r\n\r\n.infoLabel {\r\n  font-size: 13px;\r\n  font-weight: 600;\r\n  color: #718096;\r\n  text-transform: uppercase;\r\n  letter-spacing: 1px;\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.infoValue {\r\n  font-size: 17px;\r\n  color: #1a202c;\r\n  font-weight: 600;\r\n  line-height: 1.4;\r\n}\r\n\r\n.processTag {\r\n  display: inline-block;\r\n  color: #667eea;\r\n  font-weight: 600;\r\n  background: rgba(102, 126, 234, 0.1);\r\n  padding: 4px 8px;\r\n  border-radius: 6px;\r\n  margin-right: 8px;\r\n  margin-bottom: 4px;\r\n}\r\n\r\n.processAnswers {\r\n  margin-bottom: 32px;\r\n  padding: 28px;\r\n  background: linear-gradient(135deg, #ffffff 0%, #f8fafc 100%);\r\n  border-radius: 20px;\r\n  border: 1px solid rgba(102, 126, 234, 0.15);\r\n  box-shadow:\r\n    0 8px 32px rgba(102, 126, 234, 0.08),\r\n    0 2px 8px rgba(0, 0, 0, 0.04);\r\n  transition: all 0.3s ease;\r\n\r\n  &:hover {\r\n    transform: translateY(-4px);\r\n    box-shadow:\r\n      0 12px 40px rgba(102, 126, 234, 0.12),\r\n      0 4px 12px rgba(0, 0, 0, 0.08);\r\n  }\r\n}\r\n\r\n.processHeader {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  margin-bottom: 24px;\r\n  padding-bottom: 16px;\r\n  border-bottom: 2px solid rgba(102, 126, 234, 0.2);\r\n  position: relative;\r\n\r\n  &::after {\r\n    content: '';\r\n    position: absolute;\r\n    bottom: -2px;\r\n    left: 0;\r\n    width: 40px;\r\n    height: 2px;\r\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n    border-radius: 1px;\r\n  }\r\n}\r\n\r\n.processIcon {\r\n  font-size: 20px;\r\n  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));\r\n}\r\n\r\n.questionCount {\r\n  font-size: 12px;\r\n  color: #667eea;\r\n  background: rgba(102, 126, 234, 0.1);\r\n  padding: 6px 12px;\r\n  border-radius: 20px;\r\n  margin-left: auto;\r\n  font-weight: 600;\r\n  border: 1px solid rgba(102, 126, 234, 0.2);\r\n}\r\n\r\n.answersList {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 16px;\r\n}\r\n\r\n.answerItem {\r\n  display: flex;\r\n  gap: 16px;\r\n  padding: 20px;\r\n  background: linear-gradient(135deg, #ffffff 0%, #fafbfc 100%);\r\n  border-radius: 16px;\r\n  border: 1px solid rgba(102, 126, 234, 0.1);\r\n  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);\r\n  position: relative;\r\n  overflow: hidden;\r\n\r\n  &::before {\r\n    content: '';\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 3px;\r\n    height: 100%;\r\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n    transform: scaleY(0);\r\n    transition: transform 0.3s ease;\r\n  }\r\n\r\n  &:hover {\r\n    border-color: rgba(102, 126, 234, 0.3);\r\n    box-shadow:\r\n      0 8px 25px rgba(102, 126, 234, 0.1),\r\n      0 3px 10px rgba(0, 0, 0, 0.05);\r\n    transform: translateY(-2px);\r\n\r\n    &::before {\r\n      transform: scaleY(1);\r\n    }\r\n  }\r\n}\r\n\r\n.questionNumber {\r\n  flex-shrink: 0;\r\n  width: 36px;\r\n  height: 36px;\r\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n  color: white;\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 14px;\r\n  font-weight: 700;\r\n  box-shadow: 0 4px 12px rgba(102, 126, 234, 0.3);\r\n  position: relative;\r\n\r\n  &::after {\r\n    content: '';\r\n    position: absolute;\r\n    inset: -2px;\r\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n    border-radius: 50%;\r\n    z-index: -1;\r\n    opacity: 0.2;\r\n  }\r\n}\r\n\r\n.questionContent {\r\n  flex: 1;\r\n  min-width: 0;\r\n}\r\n\r\n.question {\r\n  font-weight: 600;\r\n  color: #1a202c;\r\n  margin-bottom: 12px;\r\n  font-size: 16px;\r\n  line-height: 1.5;\r\n  word-wrap: break-word;\r\n}\r\n\r\n.answer {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  flex-wrap: wrap;\r\n}\r\n\r\n.answerLabel {\r\n  font-size: 13px;\r\n  color: #718096;\r\n  font-weight: 600;\r\n  text-transform: uppercase;\r\n  letter-spacing: 0.5px;\r\n}\r\n\r\n.answerValue {\r\n  color: #667eea;\r\n  font-size: 15px;\r\n  font-weight: 700;\r\n  background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%);\r\n  padding: 8px 16px;\r\n  border-radius: 20px;\r\n  border: 1px solid rgba(102, 126, 234, 0.2);\r\n  box-shadow: 0 2px 8px rgba(102, 126, 234, 0.1);\r\n  transition: all 0.2s ease;\r\n\r\n  &:hover {\r\n    transform: translateY(-1px);\r\n    box-shadow: 0 4px 12px rgba(102, 126, 234, 0.15);\r\n  }\r\n}\r\n\r\n.finalResults {\r\n  display: grid;\r\n  grid-template-columns: 1fr;\r\n  gap: 24px;\r\n}\r\n\r\n.finalResultItem {\r\n  padding: 28px;\r\n  background: linear-gradient(135deg, #f7fafc 0%, #edf2f7 100%);\r\n  border-radius: 20px;\r\n  border: 2px solid transparent;\r\n  background-clip: padding-box;\r\n  box-shadow:\r\n    0 10px 40px rgba(102, 126, 234, 0.1),\r\n    0 4px 12px rgba(0, 0, 0, 0.05);\r\n  transition: all 0.4s cubic-bezier(0.4, 0, 0.2, 1);\r\n  position: relative;\r\n  overflow: hidden;\r\n\r\n  &::before {\r\n    content: '';\r\n    position: absolute;\r\n    inset: 0;\r\n    padding: 2px;\r\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n    border-radius: 20px;\r\n    mask: linear-gradient(#fff 0 0) content-box, linear-gradient(#fff 0 0);\r\n    mask-composite: exclude;\r\n    -webkit-mask-composite: xor;\r\n  }\r\n\r\n  &:hover {\r\n    transform: translateY(-6px) scale(1.02);\r\n    box-shadow:\r\n      0 20px 60px rgba(102, 126, 234, 0.15),\r\n      0 8px 20px rgba(0, 0, 0, 0.08);\r\n  }\r\n}\r\n\r\n.resultHeader {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 12px;\r\n  margin-bottom: 16px;\r\n}\r\n\r\n.resultIcon {\r\n  font-size: 20px;\r\n  filter: drop-shadow(0 2px 4px rgba(0, 0, 0, 0.1));\r\n}\r\n\r\n.resultProcess {\r\n  font-size: 18px;\r\n  font-weight: 700;\r\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n  -webkit-background-clip: text;\r\n  -webkit-text-fill-color: transparent;\r\n  background-clip: text;\r\n}\r\n\r\n.resultValue {\r\n  font-size: 20px;\r\n  font-weight: 800;\r\n  color: #1a202c;\r\n  background: linear-gradient(135deg, #ffffff 0%, #f7fafc 100%);\r\n  padding: 16px 20px;\r\n  border-radius: 16px;\r\n  border: 1px solid rgba(102, 126, 234, 0.2);\r\n  box-shadow:\r\n    inset 0 1px 3px rgba(255, 255, 255, 0.5),\r\n    0 4px 12px rgba(102, 126, 234, 0.1);\r\n  position: relative;\r\n\r\n  &::before {\r\n    content: '';\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    width: 4px;\r\n    height: 100%;\r\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n    border-radius: 2px 0 0 2px;\r\n  }\r\n}\r\n\r\n// 响应式设计\r\n@media (max-width: 768px) {\r\n  .detailContainer {\r\n    width: 95%;\r\n    max-height: 95vh;\r\n    border-radius: 16px;\r\n  }\r\n\r\n  .detailHeader {\r\n    padding: 20px 24px;\r\n    border-radius: 16px 16px 0 0;\r\n\r\n    h3 {\r\n      font-size: 18px;\r\n      gap: 8px;\r\n\r\n      &::before {\r\n        font-size: 16px;\r\n      }\r\n    }\r\n  }\r\n\r\n  .closeButton {\r\n    width: 36px;\r\n    height: 36px;\r\n    font-size: 18px;\r\n  }\r\n\r\n  .detailContent {\r\n    padding: 24px 20px;\r\n  }\r\n\r\n  .detailSection {\r\n    margin-bottom: 32px;\r\n\r\n    h4 {\r\n      font-size: 18px;\r\n      margin-bottom: 20px;\r\n    }\r\n  }\r\n\r\n  .infoItem {\r\n    padding: 20px;\r\n  }\r\n\r\n  .processAnswers {\r\n    padding: 20px;\r\n    margin-bottom: 24px;\r\n  }\r\n\r\n  .answerItem {\r\n    padding: 16px;\r\n    gap: 12px;\r\n  }\r\n\r\n  .questionNumber {\r\n    width: 32px;\r\n    height: 32px;\r\n    font-size: 12px;\r\n  }\r\n\r\n  .finalResultItem {\r\n    padding: 20px;\r\n  }\r\n\r\n  .resultValue {\r\n    font-size: 18px;\r\n    padding: 12px 16px;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"dialogOverlay": `ChatDialog_dialogOverlay__qFlEJ`,
	"mobile": `ChatDialog_mobile__qWT4A`,
	"dialogContainer": `ChatDialog_dialogContainer__3S3E0`,
	"dragging": `ChatDialog_dragging__p+RSv`,
	"dialogHeader": `ChatDialog_dialogHeader__gZ0Tt`,
	"closeButton": `ChatDialog_closeButton__MVmOH`,
	"messageContainer": `ChatDialog_messageContainer__o+MZn`,
	"messageWrapper": `ChatDialog_messageWrapper__MsQZ0`,
	"avatar": `ChatDialog_avatar__bzTjI`,
	"aiMessage": `ChatDialog_aiMessage__ENIl8`,
	"messageContent": `ChatDialog_messageContent__yy12T`,
	"userMessage": `ChatDialog_userMessage__5enGr`,
	"formSubmission": `ChatDialog_formSubmission__2wpwo`,
	"downloadList": `ChatDialog_downloadList__f3gnS`,
	"downloadButton": `ChatDialog_downloadButton__4YSHI`,
	"downloadButtonText": `ChatDialog_downloadButtonText__EK4NJ`,
	"downloadSub": `ChatDialog_downloadSub__DJoUg`,
	"reopenQuestionButton": `ChatDialog_reopenQuestionButton__96944`,
	"reopenQuestionSub": `ChatDialog_reopenQuestionSub__Ccc5Z`,
	"mermaidCopy": `ChatDialog_mermaidCopy__yq7Ls`,
	"inputContainer": `ChatDialog_inputContainer__exhT0`,
	"inputWrapper": `ChatDialog_inputWrapper__+a1ct`,
	"attachmentBubble": `ChatDialog_attachmentBubble__ZCpyF`,
	"attachmentText": `ChatDialog_attachmentText__ugdvl`,
	"input": `ChatDialog_input__Jeaah`,
	"disabledInput": `ChatDialog_disabledInput__ymkUu`,
	"disabledButton": `ChatDialog_disabledButton__WMLzn`,
	"withAttachment": `ChatDialog_withAttachment__NyOY4`,
	"initialQuestionnairePrompt": `ChatDialog_initialQuestionnairePrompt__6rc-9`,
	"promptText": `ChatDialog_promptText__74Ysz`,
	"promptButton": `ChatDialog_promptButton__dYokK`,
	"completed": `ChatDialog_completed__2HqdF`,
	"sendButton": `ChatDialog_sendButton__ERACI`,
	"loading": `ChatDialog_loading__YUTPP`,
	"pulse": `ChatDialog_pulse__1IsGY`,
	"questionnaireSuccess": `ChatDialog_questionnaireSuccess__I3Pq0`,
	"successContent": `ChatDialog_successContent__eSR6k`,
	"successMessage": `ChatDialog_successMessage__wkNil`,
	"viewDetailButton": `ChatDialog_viewDetailButton__A6ZwB`,
	"detailOverlay": `ChatDialog_detailOverlay__VUTEp`,
	"fadeIn": `ChatDialog_fadeIn__Nx0BR`,
	"detailContainer": `ChatDialog_detailContainer__3BIUx`,
	"slideIn": `ChatDialog_slideIn__lGH2u`,
	"detailHeader": `ChatDialog_detailHeader__3l+Is`,
	"detailContent": `ChatDialog_detailContent__6W8zV`,
	"detailSection": `ChatDialog_detailSection__CaiSh`,
	"infoGrid": `ChatDialog_infoGrid__Rec5A`,
	"infoItem": `ChatDialog_infoItem__0Hl63`,
	"infoLabel": `ChatDialog_infoLabel__3fF7g`,
	"infoValue": `ChatDialog_infoValue__j0q5-`,
	"processTag": `ChatDialog_processTag__8X84Z`,
	"processAnswers": `ChatDialog_processAnswers__v8DQw`,
	"processHeader": `ChatDialog_processHeader__vwxtI`,
	"processIcon": `ChatDialog_processIcon__8AFFH`,
	"questionCount": `ChatDialog_questionCount__MkKAO`,
	"answersList": `ChatDialog_answersList__gHfRO`,
	"answerItem": `ChatDialog_answerItem__LbFKC`,
	"questionNumber": `ChatDialog_questionNumber__r4N6e`,
	"questionContent": `ChatDialog_questionContent__VgLUL`,
	"question": `ChatDialog_question__U7ING`,
	"answer": `ChatDialog_answer__1jqBL`,
	"answerLabel": `ChatDialog_answerLabel__k4HqH`,
	"answerValue": `ChatDialog_answerValue__P+cBN`,
	"finalResults": `ChatDialog_finalResults__PIjjh`,
	"finalResultItem": `ChatDialog_finalResultItem__hxx3y`,
	"resultHeader": `ChatDialog_resultHeader__e67if`,
	"resultIcon": `ChatDialog_resultIcon__agWWl`,
	"resultProcess": `ChatDialog_resultProcess__8c5Y0`,
	"resultValue": `ChatDialog_resultValue__V-rF2`
};
export default ___CSS_LOADER_EXPORT___;
